import { validationLength } from "../components/actions/validations";

const textMax = validationLength.departmentName;
const longTextMax = validationLength.reservationGuestNotesText;

const spaceRule = (max: number) =>
  `Max ${max} characters; letters, numbers and spaces only; no special characters.`;

const nameRule = (max: number) =>
  `Max ${max} characters; line breaks not allowed.`;

const digitsRule = `Digits only; max ${textMax} characters.`;

/** Default (non-error) helper text under Reserve Equipments/Add-ons fields. */
export const reserveEquipmentsAddonsFieldHelperText = {
  addOnName: `${spaceRule(textMax)} Mandatory.`,
  addOnType: `${spaceRule(textMax)} Mandatory.`,
  addOnDescription: `${nameRule(longTextMax)} Optional.`,
  addOnCategory: `${spaceRule(textMax)} Optional.`,
  addOnSubCategory: `${spaceRule(textMax)} Optional.`,
  qtyInStock: `${digitsRule} Optional.`,
  price: `${nameRule(textMax)} Optional.`,
  additionalRatesPerMins: `${digitsRule} Optional.`,
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveEquipmentsAddonsFieldErrors = {
  required: "This field is required.",
  addOnName: spaceRule(textMax),
  addOnType: spaceRule(textMax),
  addOnDescription: nameRule(longTextMax),
  addOnCategory: spaceRule(textMax),
  addOnSubCategory: spaceRule(textMax),
  qtyInStock: digitsRule,
  price: nameRule(textMax),
  additionalRatesPerMins: digitsRule,
} as const;
